import { ARC_NUMBER_TYPE } from "@visactor/vrender-core";

import { PickerBase } from "../common/base";

export class DefaultCanvasArcPicker extends PickerBase {
    constructor(canvasRenderer) {
        super(), this.canvasRenderer = canvasRenderer, this.type = "arc", this.numberType = ARC_NUMBER_TYPE;
    }
}
//# sourceMappingURL=arc-picker.js.map
